import React from 'react'
import { Selector } from 'antd-mobile'
import type { ExpenseType } from '@/types'
import { useIsMobile } from '@/hooks/useIsMobile'

interface ExpenseTypeSelectorProps {
  value: ExpenseType
  onChange: (expenseType: ExpenseType) => void
  disabled?: boolean
}

const ExpenseTypeSelectorResponsive: React.FC<ExpenseTypeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const isMobile = useIsMobile()

  // 移动端：antd-mobile Selector
  if (isMobile) {
    const options = [
      { label: '部门承担', value: 'DEPARTMENT' },
      { label: '自费', value: 'SELF_PAID' },
    ]
    return (
      <div>
        <label className="heading-2 mb-clay-sm block">出差类型 <span className="text-red-500">*</span></label>
        <Selector
          options={options}
          value={[value]}
          disabled={disabled}
          onChange={(arr) => {
            if (arr.length > 0) onChange(arr[0] as ExpenseType)
          }}
        />
        <p className="hint-text mt-2">
          {value === 'SELF_PAID'
            ? '自费模式：费用由个人承担，公司不予报销'
            : '部门承担：费用由部门承担，受预算管控'}
        </p>
      </div>
    )
  }

  // PC端：保持原有 claymorphism 风格
  return (
    <div>
      <label className="heading-2 mb-clay-sm block">出差类型 <span className="text-red-500">*</span></label>
      <div className="required-field">
        <select
          className="clay-input w-full appearance-none"
          value={value}
          onChange={(e) => onChange(e.target.value as ExpenseType)}
          disabled={disabled}
        >
          <option value="DEPARTMENT">部门承担</option>
          <option value="SELF_PAID">自费</option>
        </select>
      </div>
      <p className="hint-text mt-2">
        {value === 'SELF_PAID'
          ? '自费模式：费用由个人承担，公司不予报销'
          : '部门承担：费用由部门承担，受预算管控'}
      </p>
    </div>
  )
}

export default ExpenseTypeSelectorResponsive
